module.exports = __webpack_public_path__ + "img/660.55b0ac31.jpg";